import { apiClient } from "@/lib/api/client";
import { buildQueryString } from "@/lib/utils/query-string";

// Public Categories
const CAT_BASE = "/api/catalog/public/category/";

export async function listPublicCategories(params?: Record<string, unknown>) {
  const query = params ? buildQueryString(params) : "";
  const { data } = await apiClient.get(`${CAT_BASE}${query ? `?${query}` : ""}`);
  return data;
}

export async function getPublicCategory(id: number) {
  const { data } = await apiClient.get(`${CAT_BASE}${id}/`);
  return data;
}

export async function createPublicCategory(payload: Record<string, unknown>) {
  const { data } = await apiClient.post(CAT_BASE, payload);
  return data;
}

export async function updatePublicCategory(id: number, payload: Record<string, unknown>) {
  const { data } = await apiClient.patch(`${CAT_BASE}${id}/`, payload);
  return data;
}

export async function deletePublicCategory(id: number) {
  const { data } = await apiClient.delete(`${CAT_BASE}${id}/`);
  return data;
}

export async function addSubCategoryToCategory(id: number, payload: Record<string, unknown>) {
  const { data } = await apiClient.post(`${CAT_BASE}${id}/add_subcategory/`, payload);
  return data;
}

export async function moveSubCategory(id: number, payload: Record<string, unknown>) {
  const { data } = await apiClient.post(`${CAT_BASE}${id}/move_subcategory/`, payload);
  return data;
}

export async function moveCategory(id: number, payload: Record<string, unknown>) {
  const { data } = await apiClient.post(`${CAT_BASE}${id}/move_category/`, payload);
  return data;
}

// Public SubCategories
const SUB_BASE = "/api/catalog/public/subcategory/";

export async function listPublicSubCategories(params?: Record<string, unknown>) {
  const query = params ? buildQueryString(params) : "";
  const { data } = await apiClient.get(`${SUB_BASE}${query ? `?${query}` : ""}`);
  return data;
}

export async function getPublicSubCategory(id: number) {
  const { data } = await apiClient.get(`${SUB_BASE}${id}/`);
  return data;
}

export async function createPublicSubCategory(payload: Record<string, unknown>) {
  const { data } = await apiClient.post(SUB_BASE, payload);
  return data;
}

export async function updatePublicSubCategory(id: number, payload: Record<string, unknown>) {
  const { data } = await apiClient.patch(`${SUB_BASE}${id}/`, payload);
  return data;
}

export async function deletePublicSubCategory(id: number) {
  const { data } = await apiClient.delete(`${SUB_BASE}${id}/`);
  return data;
}

export async function moveGroup(subCategoryId: number, payload: Record<string, unknown>) {
  const { data } = await apiClient.post(`${SUB_BASE}${subCategoryId}/move_group/`, payload);
  return data;
}

export async function addGroupToSubCategory(subCategoryId: number, payload: Record<string, unknown>) {
  const { data } = await apiClient.post(`${SUB_BASE}${subCategoryId}/add_group/`, payload);
  return data;
}

export async function removeGroupFromSubCategory(subCategoryId: number, payload: Record<string, unknown>) {
  const { data } = await apiClient.post(`${SUB_BASE}${subCategoryId}/remove_group/`, payload);
  return data;
}

// Browse (public, no auth)
export async function browseCatalog() {
  const { data } = await apiClient.get(`${CAT_BASE}browse/`);
  return data;
}
